import React from "react";
import { SmallCard } from "styled_components/Common/SmallCard";
import styled from "styled-components";
import ScrollView from "sub_components/Common/BloxScrollViewNew";

function renderCards(data, selected, onClick, type) {
  return data.map((item, index) => {
    return (
      <SmallCard
        key={`user-card-${item?.id}-${index + 1}`}
        selected={
          parseInt(item?.id) === parseInt(selected) ? "xs selected" : "xs"
        }
        cypressId={`card-${index}`}
        onClick={onClick}
        data={item}
        id={item?.id}
        pending={item?.pending}
        deleted={item?.deleted}
        index={index}
        type={type}
      />
    );
  });
}

const CardScrollerVerticalStyle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${(props) => props.theme.componentBackground};
  .cards-wrapper {
    width: 120px;
    height: 500px;
    margin-left: 10px;
    &.invoice {
      margin-left: 2px;
      .ScrollbarsCustom-Track {
        right: 11px !important;
        top: 10px !important;
      }
    }
    .small-card {
      margin-bottom: 20px;
    }

    .ScrollbarsCustom-Track {
      right: 7px !important;
      top: 10px !important;
    }
    .ScrollbarsCustom-ThumbY {
      background-color: ${(props) =>
        props.module === "billing"
          ? props?.theme?.billing
          : props?.theme?.storage} !important;
      width: 6px !important;
    }
    .ScrollbarsCustom-TrackY:before {
      border-left: none;
    }
    .ScrollbarsCustom-TrackY {
      background-color: ${(props) => props.theme.Cool_Gray_Light_2} !important;
      box-shadow: -1px -1px 1.5px ${(props) => props.theme.Cool_Gray_Light_3} inset,
        1px 1px 1.5px ${(props) => props.theme.Cool_Gray_Med_2} inset;
      width: 6px !important;
    }
  }
  .buttons-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;

    height: 50px;
  }

  @media screen and (min-width: ${(props) =>
      props.theme.res.medium}) and (max-width: ${(props) =>
      props.theme.res.high}) {
    .cards-wrapper {
      width: 160px;
      height: 630px;
      margin-left: 20px;
      .small-card {
        margin-bottom: 20px;
      }

      &.invoice {
        margin-left: 10px;
      }

      .ScrollbarsCustom-Track {
        right: 8px !important;
        top: 10px !important;
      }
      .ScrollbarsCustom-ThumbY {
        background-color: ${(props) =>
          props.module === "billing"
            ? props?.theme?.billing
            : props?.theme?.storage} !important;
        width: 9px !important;
      }
      .ScrollbarsCustom-TrackY:before {
        border-left: none;
      }
      .ScrollbarsCustom-TrackY {
        width: 8px !important;
      }
    }
    .buttons-wrapper {
      button {
        width: 120px;
      }
      height: 75px;
    }
  }
  @media screen and (min-width: ${(props) => props.theme.res.high}) {
    .cards-wrapper {
      width: 265px;
      height: 850px;
      margin-left: 20px;
      .small-card {
        margin-bottom: 30px;
      }
      &.invoice {
        margin-left: 15px;
        .ScrollbarsCustom-Track {
          right: 20px !important;
          top: 10px !important;
        }
      }

      .ScrollbarsCustom-Track {
        right: 14px !important;
        top: 25px !important;
      }
      .ScrollbarsCustom-ThumbY {
        background-color: ${(props) =>
          props.module === "billing"
            ? props?.theme?.billing
            : props?.theme?.storage} !important;
        width: 8px !important;
      }
      .ScrollbarsCustom-TrackY:before {
        border-left: none;
      }
      .ScrollbarsCustom-TrackY {
        width: 8px !important;
      }
    }
    .buttons-wrapper {
      button {
        width: 200px;
      }
      height: 125px;
    }
  }
`;

export const CardScrollerVertical = ({
  data,
  button,
  selected,
  onClick,
  type,
  module,
}) => {
  return (
    <CardScrollerVerticalStyle
      module={module}
      className="card-scroller-vertical"
    >
      {button && <div className="buttons-wrapper">{button}</div>}
      <div className={`cards-wrapper ${type}`}>
        <ScrollView>
          {data && renderCards(data, selected, onClick, type)}
        </ScrollView>
      </div>
    </CardScrollerVerticalStyle>
  );
};
